/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	document.addEventListener("DOMContentLoaded", function () {
	  var cookieAccessToken = getCookie("access_token");
	  var uri = window.location.href;
	  var path = location.href.replace(/.*\/\/[^\/]*/, '');
	  var pathname = path;
	  var pathParams = '';
	  if (path.indexOf('?') > -1) {
	    pathname = path.split('?')[0];
	    pathParams = path.substr(path.indexOf('?'));
	  }
	  var params = loadParams(uri);
	  if (cookieAccessToken || uri.indexOf("password") != -1 || params["uuid"]) {
	
	    // prevent access password_edit without logged-in or token
	    if (uri.indexOf('password_edit') != -1 && !params['token']) {
	      location.href = '/lp/index.html';
	      return;
	    }
	    loadMainJS(params);
	  } else {
	    var querys = uri.indexOf('?') != -1 ? uri.slice(uri.indexOf('?')) : '';
	    var date1 = new Date();
	    var isLogout = localStorage.getItem('logout');
	    date1.setTime(0);
	    document.cookie = "access_token=;expires=" + date1.toGMTString();
	    document.cookie = "society_" + ("production") + "_access_token=;expires=" + date1.toGMTString();
	    if (pathname === "/" || pathname === "/#/" || pathname === "/#/user" || isLogout) {
	      location.href = "/lp/index.html" + pathParams;
	      localStorage.clear();
	    } else if (pathname === '/#/login' || pathname === '/login') {
	      location.href = "/lp/index.html?login";
	    } else {
	      sessionStorage.setItem('reservationPath', pathname);
	      location.href = "/lp/access-denied.html";
	    }
	  }
	});
	
	function loadParams(uri) {
	  var vars = [];
	  var hash;
	  var hashes = uri.slice(uri.indexOf('?') + 1).split('&');
	  for (var i = 0; i < hashes.length; i++) {
	    hash = hashes[i].split('=');
	    vars.push(hash[0]);
	    vars[hash[0]] = decodeURI(hash[1]);
	  }
	  return vars;
	}
	
	function loadMainJS() {
	  var scripts = ['/lib/app.js?d=' + ("v1750235607316"), '/bower_components/modernizr/modernizr.js'];
	  var len = scripts.length;
	  var i = 0;
	
	  (function appendScript() {
	    var script = document.createElement('script');
	    script.src = scripts[i];
	    document.body.appendChild(script);
	    if (i < len - 1) {
	      i++;
	      script.onload = appendScript;
	    }
	  })();
	}
	
	//クッキー取得
	function getCookie(name) {
	  var result = [];
	  var cookies = document.cookie;
	  if (cookies != '') {
	    var cookiesAry = cookies.split(';');
	    for (var i = 0; i < cookiesAry.length; i++) {
	      var cookie = cookiesAry[i].trim().split('=');
	      result[cookie[0]] = decodeURIComponent(cookie[1]);
	    }
	  }
	  return result[name];
	}

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** starter.js
 **/